// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.analytics-dashboard {
  background: #e5052a;
  min-height: 100vh;
  padding: clamp(2rem, 5vw, 4rem) 0;
}
.analytics-dashboard .password-prompt {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 80vh;
  padding: 2rem;
}
.analytics-dashboard .password-prompt .password-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  padding: 3rem;
  max-width: 450px;
  width: 100%;
  text-align: center;
}
@media (max-width: 767.98px) {
  .analytics-dashboard .password-prompt .password-card {
    padding: 2rem;
  }
}
.analytics-dashboard .password-prompt .password-card h2 {
  font-size: 2rem;
  font-weight: 700;
  color: #e5052a;
  margin-bottom: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
@media (max-width: 767.98px) {
  .analytics-dashboard .password-prompt .password-card h2 {
    font-size: 1.5rem;
  }
}
.analytics-dashboard .password-prompt .password-card p {
  color: #666;
  font-size: 1rem;
  margin-bottom: 2rem;
  line-height: 1.5;
}
.analytics-dashboard .password-prompt .password-card form .form-group {
  margin-bottom: 1.5rem;
}
.analytics-dashboard .password-prompt .password-card form .form-group .password-input {
  width: 100%;
  padding: 1rem 1.5rem;
  font-size: 1rem;
  border: 2px solid #e0e0e0;
  border-radius: 50px;
  outline: none;
  transition: all 0.3s ease;
  font-family: inherit;
}
.analytics-dashboard .password-prompt .password-card form .form-group .password-input:focus {
  border-color: #00823d;
  box-shadow: 0 0 0 3px rgba(0, 130, 61, 0.1);
}
.analytics-dashboard .password-prompt .password-card form .form-group .password-input.error {
  border-color: #e5052a;
}
.analytics-dashboard .password-prompt .password-card form .form-group .password-input::placeholder {
  color: #999;
}
.analytics-dashboard .password-prompt .password-card form .form-group .error-message {
  color: #e5052a;
  font-size: 0.875rem;
  margin-top: 0.75rem;
  font-weight: 500;
  text-align: left;
  padding-left: 1.5rem;
}
.analytics-dashboard .password-prompt .password-card form .btn-submit {
  width: 100%;
  padding: 1rem 2rem;
  background-color: #00823d;
  color: white;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 8px rgba(0, 130, 61, 0.2);
}
.analytics-dashboard .password-prompt .password-card form .btn-submit:hover {
  background-color: rgb(0, 89.2, 41.8553846154);
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 130, 61, 0.3);
}
.analytics-dashboard .password-prompt .password-card form .btn-submit:active {
  transform: translateY(0);
}
.analytics-dashboard .analytics-header,
.analytics-dashboard .summary-section,
.analytics-dashboard .trend-section {
  max-width: 1400px;
  margin: 0 auto;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
@media (max-width: 767.98px) {
  .analytics-dashboard .analytics-header,
  .analytics-dashboard .summary-section,
  .analytics-dashboard .trend-section {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
.analytics-dashboard .analytics-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding-top: 2rem;
  padding-bottom: 2rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
@media (max-width: 767.98px) {
  .analytics-dashboard .analytics-header {
    flex-direction: column;
    gap: 1rem;
    padding: 1.5rem;
  }
}
.analytics-dashboard .analytics-header .dashboard-title {
  font-size: clamp(1.5rem, 4vw, 2.5rem);
  font-weight: 700;
  color: #e5052a;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
@media (max-width: 767.98px) {
  .analytics-dashboard .analytics-header .dashboard-title {
    font-size: 1.5rem;
    text-align: center;
  }
}
.analytics-dashboard .analytics-header .btn-refresh {
  padding: 0.875rem 2rem;
  background-color: #00823d;
  color: white;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 8px rgba(0, 130, 61, 0.2);
}
.analytics-dashboard .analytics-header .btn-refresh:hover {
  background-color: rgb(0, 89.2, 41.8553846154);
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 130, 61, 0.3);
}
.analytics-dashboard .analytics-header .btn-refresh:active {
  transform: translateY(0);
}
@media (max-width: 767.98px) {
  .analytics-dashboard .analytics-header .btn-refresh {
    width: 100%;
  }
}
.analytics-dashboard .loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  min-height: 300px;
  background: white;
  border-radius: 12px;
}
.analytics-dashboard .loading-container.small {
  min-height: 150px;
  padding: 2rem;
}
.analytics-dashboard .loading-container .spinner {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid #00823d;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}
.analytics-dashboard .loading-container .spinner.small {
  width: 30px;
  height: 30px;
  border-width: 3px;
}
.analytics-dashboard .loading-container p {
  color: #666;
  font-size: 1rem;
  margin: 0;
  font-weight: 500;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.analytics-dashboard .section-title {
  font-size: clamp(1.5rem, 3vw, 2rem);
  font-weight: 700;
  color: white;
  margin-bottom: 1.5rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  text-align: center;
}
@media (max-width: 767.98px) {
  .analytics-dashboard .section-title {
    font-size: 1.5rem;
  }
}
.analytics-dashboard .summary-section {
  margin-bottom: 3rem;
}
.analytics-dashboard .summary-section .summary-cards {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 1.5rem;
}
@media (max-width: 991.98px) {
  .analytics-dashboard .summary-section .summary-cards {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 767.98px) {
  .analytics-dashboard .summary-section .summary-cards {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 575.98px) {
  .analytics-dashboard .summary-section .summary-cards {
    grid-template-columns: 1fr;
  }
}
.analytics-dashboard .summary-section .summary-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  transition: all 0.3s ease;
}
.analytics-dashboard .summary-section .summary-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
}
.analytics-dashboard .summary-section .summary-card .card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  background: #00823d;
  color: white;
}
.analytics-dashboard .summary-section .summary-card .card-header h3 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.analytics-dashboard .summary-section .summary-card .card-header .card-icon {
  font-size: 2rem;
}
.analytics-dashboard .summary-section .summary-card .card-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 1.5rem;
  min-height: 200px;
}
.analytics-dashboard .summary-section .summary-card .card-loading .spinner {
  width: 30px;
  height: 30px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #00823d;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 0.5rem;
}
.analytics-dashboard .summary-section .summary-card .card-loading .spinner.small {
  width: 24px;
  height: 24px;
  border-width: 2px;
}
.analytics-dashboard .summary-section .summary-card .card-loading p {
  color: #666;
  font-size: 0.875rem;
  margin: 0;
}
.analytics-dashboard .summary-section .summary-card .card-body {
  padding: 1.5rem;
}
.analytics-dashboard .summary-section .summary-card .card-body .stat-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1.5rem;
}
.analytics-dashboard .summary-section .summary-card .card-body .stat-main .stat-value {
  font-size: 2.75rem;
  font-weight: 700;
  color: #00823d;
  line-height: 1;
}
.analytics-dashboard .summary-section .summary-card .card-body .stat-main .stat-value.small {
  font-size: 1.5rem;
}
.analytics-dashboard .summary-section .summary-card .card-body .stat-main .stat-label {
  font-size: 0.9rem;
  color: #666;
  margin-top: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
}
.analytics-dashboard .summary-section .summary-card .card-body .stat-percentage {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1.5rem;
  padding: 1rem;
  background: rgb(253.4615384615, 184.5384615385, 195.9230769231);
  border-radius: 8px;
}
.analytics-dashboard .summary-section .summary-card .card-body .stat-percentage.success {
  background: rgb(253.4615384615, 184.5384615385, 195.9230769231);
}
.analytics-dashboard .summary-section .summary-card .card-body .stat-percentage .percentage-value {
  font-size: 2rem;
  font-weight: 700;
  color: #e5052a;
}
.analytics-dashboard .summary-section .summary-card .card-body .stat-percentage .percentage-label {
  font-size: 0.85rem;
  color: #666;
  margin-top: 0.25rem;
  font-weight: 500;
}
.analytics-dashboard .summary-section .summary-card .card-body .stat-row {
  display: flex;
  justify-content: space-around;
  gap: 1rem;
  margin-bottom: 1rem;
}
.analytics-dashboard .summary-section .summary-card .card-body .stat-row .stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}
.analytics-dashboard .summary-section .summary-card .card-body .stat-row .stat-item .stat-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #cca374;
}
.analytics-dashboard .summary-section .summary-card .card-body .stat-row .stat-item .stat-value.small {
  font-size: 1.25rem;
}
.analytics-dashboard .summary-section .summary-card .card-body .stat-row .stat-item .stat-label {
  font-size: 0.75rem;
  color: #999;
  margin-top: 0.25rem;
  text-transform: uppercase;
  font-weight: 600;
}
.analytics-dashboard .summary-section .summary-card .card-body .stat-breakdown {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1rem;
}
.analytics-dashboard .summary-section .summary-card .card-body .stat-breakdown .breakdown-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.875rem;
  border-radius: 8px;
  background: #eaedd2;
}
.analytics-dashboard .summary-section .summary-card .card-body .stat-breakdown .breakdown-item.pending {
  background: rgb(255, 239.7, 178.5);
  border-left: 4px solid #ffcc00;
}
.analytics-dashboard .summary-section .summary-card .card-body .stat-breakdown .breakdown-item.partial {
  background: rgb(251.9131578947, 249.4315789474, 246.5868421053);
  border-left: 4px solid #cca374;
}
.analytics-dashboard .summary-section .summary-card .card-body .stat-breakdown .breakdown-item.completed {
  background: rgb(130, 255, 188.6538461538);
  border-left: 4px solid #00823d;
}
.analytics-dashboard .summary-section .summary-card .card-body .stat-breakdown .breakdown-item.approved {
  background: rgb(130, 255, 188.6538461538);
  border-left: 4px solid #00823d;
}
.analytics-dashboard .summary-section .summary-card .card-body .stat-breakdown .breakdown-item.handled {
  background: rgb(251.9131578947, 249.4315789474, 246.5868421053);
  border-left: 4px solid #cca374;
}
.analytics-dashboard .summary-section .summary-card .card-body .stat-breakdown .breakdown-item .breakdown-value {
  font-size: 1.25rem;
  font-weight: 700;
  color: #333;
}
.analytics-dashboard .summary-section .summary-card .card-body .stat-breakdown .breakdown-item .breakdown-label {
  font-size: 0.85rem;
  color: #666;
  font-weight: 500;
}
.analytics-dashboard .summary-section .summary-card .card-body .stat-footer {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding-top: 1rem;
  border-top: 2px solid #e0e0e0;
}
.analytics-dashboard .summary-section .summary-card .card-body .stat-footer small {
  font-size: 0.8rem;
  color: #999;
  font-weight: 500;
}
.analytics-dashboard .trend-section {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 2rem;
  margin-bottom: 2rem;
}
@media (max-width: 767.98px) {
  .analytics-dashboard .trend-section {
    padding: 1.5rem;
  }
}
.analytics-dashboard .trend-section .section-title {
  color: #e5052a;
  text-align: left;
  margin-bottom: 1rem;
}
.analytics-dashboard .trend-section .trend-header {
  margin-bottom: 2rem;
}
.analytics-dashboard .trend-section .trend-header .controls-group {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 1rem;
}
@media (max-width: 767.98px) {
  .analytics-dashboard .trend-section .trend-header .controls-group {
    flex-direction: column;
    align-items: stretch;
  }
}
.analytics-dashboard .trend-section .trend-header .controls-group .category-selector {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}
@media (max-width: 575.98px) {
  .analytics-dashboard .trend-section .trend-header .controls-group .category-selector {
    flex-direction: column;
  }
}
.analytics-dashboard .trend-section .trend-header .controls-group .category-selector .category-btn {
  padding: 0.75rem 1.25rem;
  background: white;
  border: 2px solid #00823d;
  border-radius: 50px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 600;
  color: #00823d;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.analytics-dashboard .trend-section .trend-header .controls-group .category-selector .category-btn:hover {
  background: rgb(130, 255, 188.6538461538);
}
.analytics-dashboard .trend-section .trend-header .controls-group .category-selector .category-btn.active {
  background: #00823d;
  color: white;
  box-shadow: 0 4px 8px rgba(0, 130, 61, 0.2);
}
@media (max-width: 575.98px) {
  .analytics-dashboard .trend-section .trend-header .controls-group .category-selector .category-btn {
    width: 100%;
    text-align: center;
  }
}
.analytics-dashboard .trend-section .trend-header .controls-group .time-range-selector {
  display: flex;
  gap: 0.25rem;
  background: #eaedd2;
  padding: 0.25rem;
  border-radius: 50px;
}
@media (max-width: 767.98px) {
  .analytics-dashboard .trend-section .trend-header .controls-group .time-range-selector {
    width: 100%;
  }
}
.analytics-dashboard .trend-section .trend-header .controls-group .time-range-selector .range-btn {
  padding: 0.625rem 1.5rem;
  background: transparent;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 600;
  color: #666;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  flex: 1;
}
.analytics-dashboard .trend-section .trend-header .controls-group .time-range-selector .range-btn:hover {
  background: rgb(225.5, 229.7142857143, 191.7857142857);
}
.analytics-dashboard .trend-section .trend-header .controls-group .time-range-selector .range-btn.active {
  background: #00823d;
  color: white;
  box-shadow: 0 2px 6px rgba(0, 130, 61, 0.3);
}
.analytics-dashboard .trend-section .trend-content .chart-wrapper .chart-container {
  position: relative;
  height: 450px;
  width: 100%;
  padding: 1.5rem;
  background: white;
  border-radius: 12px;
  border: 2px solid #eaedd2;
  margin-bottom: 1.5rem;
}
@media (max-width: 767.98px) {
  .analytics-dashboard .trend-section .trend-content .chart-wrapper .chart-container {
    height: 300px;
    padding: 1rem;
  }
}
.analytics-dashboard .trend-section .trend-content .chart-wrapper .chart-container canvas {
  max-height: 100%;
}
.analytics-dashboard .trend-section .trend-content .chart-wrapper .chart-stats {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 2rem;
  padding: 1.5rem;
  background: #eaedd2;
  border-radius: 12px;
}
@media (max-width: 575.98px) {
  .analytics-dashboard .trend-section .trend-content .chart-wrapper .chart-stats {
    gap: 1rem;
  }
}
.analytics-dashboard .trend-section .trend-content .chart-wrapper .chart-stats .stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}
.analytics-dashboard .trend-section .trend-content .chart-wrapper .chart-stats .stat-item .stat-label {
  font-size: 0.85rem;
  color: #666;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.analytics-dashboard .trend-section .trend-content .chart-wrapper .chart-stats .stat-item .stat-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #00823d;
}
@media (max-width: 575.98px) {
  .analytics-dashboard .trend-section .trend-content .chart-wrapper .chart-stats .stat-item .stat-value {
    font-size: 1.25rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/analytics/analytics.component.scss","webpack://./src/assets/styles/colors.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss"],"names":[],"mappings":"AAUA;EACE,mBCPI;EDQJ,iBAAA;EACA,iCAAA;AATF;AAYE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;AAVJ;AAYI;EACE,iBAAA;EACA,mBAAA;EACA,yCAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AAVN;AEwDI;EFrDA;IAUI,aAAA;EATN;AACF;AAWM;EACE,eAAA;EACA,gBAAA;EACA,cCnCF;EDoCE,mBAAA;EACA,yBAAA;EACA,qBAAA;AATR;AE2CI;EFxCE;IASI,iBAAA;EARR;AACF;AAWM;EACE,WAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AATR;AAaQ;EACE,qBAAA;AAXV;AAaU;EACE,WAAA;EACA,oBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,oBAAA;AAXZ;AAaY;EACE,qBCtEN;EDuEM,2CAAA;AAXd;AAcY;EACE,qBCxER;AD4DN;AAeY;EACE,WAAA;AAbd;AAiBU;EACE,cCjFN;EDkFM,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;AAfZ;AAmBQ;EACE,WAAA;EACA,kBAAA;EACA,yBChGF;EDiGE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,2CAAA;AAjBV;AAmBU;EACE,6CAAA;EACA,2BAAA;EACA,4CAAA;AAjBZ;AAoBU;EACE,wBAAA;AAlBZ;AA0BE;;;EAGE,iBAAA;EACA,cAAA;EACA,oBAAA;EACA,qBAAA;AAxBJ;AE9BI;EFgDF;;;IASI,kBAAA;IACA,mBAAA;EArBJ;AACF;AAyBE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,iBAAA;EACA,mBAAA;EACA,0CAAA;AAvBJ;AEjDI;EF+DF;IAYI,sBAAA;IACA,SAAA;IACA,eAAA;EAtBJ;AACF;AAwBI;EACE,qCAAA;EACA,gBAAA;EACA,cC3JA;ED4JA,SAAA;EACA,yBAAA;EACA,qBAAA;AAtBN;AEhEI;EFgFA;IASI,iBAAA;IACA,kBAAA;EArBN;AACF;AAwBI;EACE,sBAAA;EACA,yBC3KE;ED4KF,YAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,2CAAA;AAtBN;AAwBM;EACE,6CAAA;EACA,2BAAA;EACA,4CAAA;AAtBR;AAyBM;EACE,wBAAA;AAvBR;AE5FI;EF8FA;IAyBI,WAAA;EAvBN;AACF;AA4BE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;AA1BJ;AA4BI;EACE,iBAAA;EACA,aAAA;AA1BN;AA6BI;EACE,WAAA;EACA,YAAA;EACA,0CAAA;EACA,6BAAA;EACA,kBAAA;EACA,kCAAA;EACA,mBAAA;AA3BN;AA6BM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA3BR;AA+BI;EACE,WAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;AA7BN;AAiCE;EACE;IAAK,uBAAA;EA9BP;EA+BE;IAAO,yBAAA;EA5BT;AACF;AA+BE;EACE,mCAAA;EACA,gBAAA;EACA,YAAA;EACA,qBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AA7BJ;AEpJI;EF0KF;IAUI,iBAAA;EA5BJ;AACF;AAgCE;EACE,mBAAA;AA9BJ;AAgCI;EACE,aAAA;EACA,qCAAA;EACA,WAAA;AA9BN;AEjKI;EF4LA;IAMI,qCAAA;EA7BN;AACF;AEtKI;EF4LA;IAUI,qCAAA;EA5BN;AACF;AE3KI;EF4LA;IAcI,0BAAA;EA3BN;AACF;AA8BI;EACE,iBAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA;EACA,yBAAA;AA5BN;AA8BM;EACE,2BAAA;EACA,yCAAA;AA5BR;AA+BM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,mBC1SA;ED2SA,YAAA;AA7BR;AA+BQ;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AA7BV;AAgCQ;EACE,eAAA;AA9BV;AAkCM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,iBAAA;AAhCR;AAkCQ;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,kCAAA;EACA,qBAAA;AAhCV;AAkCU;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAhCZ;AAoCQ;EACE,WAAA;EACA,mBAAA;EACA,SAAA;AAlCV;AAsCM;EACE,eAAA;AApCR;AAsCQ;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,qBAAA;AApCV;AAsCU;EACE,kBAAA;EACA,gBAAA;EACA,cCrWJ;EDsWI,cAAA;AApCZ;AAsCY;EACE,iBAAA;AApCd;AAwCU;EACE,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AAtCZ;AA0CQ;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,qBAAA;EACA,aAAA;EACA,+DAAA;EACA,kBAAA;AAxCV;AA0CU;EACE,+DAAA;AAxCZ;AA2CU;EACE,eAAA;EACA,gBAAA;EACA,cCpYN;AD2VN;AA4CU;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;AA1CZ;AA8CQ;EACE,aAAA;EACA,6BAAA;EACA,SAAA;EACA,mBAAA;AA5CV;AA8CU;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,OAAA;AA5CZ;AA8CY;EACE,iBAAA;EACA,gBAAA;EACA,cClaN;ADsXR;AA8Cc;EACE,kBAAA;AA5ChB;AAgDY;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AA9Cd;AAmDQ;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;AAjDV;AAmDU;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBC7bE;AD4Yd;AAmDY;EACE,kCAAA;EACA,8BAAA;AAjDd;AAoDY;EACE,+DAAA;EACA,8BAAA;AAlDd;AAqDY;EACE,yCAAA;EACA,8BAAA;AAnDd;AAsDY;EACE,yCAAA;EACA,8BAAA;AApDd;AAuDY;EACE,+DAAA;EACA,8BAAA;AArDd;AAwDY;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;AAtDd;AAyDY;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AAvDd;AA4DQ;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,6BAAA;AA1DV;AA4DU;EACE,iBAAA;EACA,WAAA;EACA,gBAAA;AA1DZ;AAkEE;EACE,iBAAA;EACA,mBAAA;EACA,0CAAA;EACA,aAAA;EACA,mBAAA;AAhEJ;AEnXI;EF8aF;IAQI,eAAA;EA/DJ;AACF;AAiEI;EACE,cClgBA;EDmgBA,gBAAA;EACA,mBAAA;AA/DN;AAkEI;EACE,mBAAA;AAhEN;AAkEM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;AAhER;AExYI;EFkcE;IASI,sBAAA;IACA,oBAAA;EA/DR;AACF;AAiEQ;EACE,aAAA;EACA,WAAA;EACA,eAAA;AA/DV;AEnZI;EF+cI;IAMI,sBAAA;EA9DV;AACF;AAgEU;EACE,wBAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cC3iBJ;ED4iBI,yBAAA;EACA,yBAAA;EACA,qBAAA;AA9DZ;AAgEY;EACE,yCAAA;AA9Dd;AAiEY;EACE,mBCrjBN;EDsjBM,YAAA;EACA,2CAAA;AA/Dd;AE7aI;EFwdM;IAwBI,WAAA;IACA,kBAAA;EA/DZ;AACF;AAmEQ;EACE,aAAA;EACA,YAAA;EACA,mBCnkBI;EDokBJ,gBAAA;EACA,mBAAA;AAjEV;AE1bI;EFsfI;IAQI,WAAA;EAhEV;AACF;AAkEU;EACE,wBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,qBAAA;EACA,OAAA;AAhEZ;AAkEY;EACE,sDAAA;AAhEd;AAmEY;EACE,mBC/lBN;EDgmBM,YAAA;EACA,2CAAA;AAjEd;AA0EQ;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;AAxEV;AE/dI;EF+hBI;IAWI,aAAA;IACA,aAAA;EAvEV;AACF;AAyEU;EACE,gBAAA;AAvEZ;AA2EQ;EACE,aAAA;EACA,uBAAA;EACA,eAAA;EACA,SAAA;EACA,eAAA;EACA,mBCnoBI;EDooBJ,mBAAA;AAzEV;AEjfI;EFmjBI;IAUI,SAAA;EAxEV;AACF;AA0EU;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AAxEZ;AA0EY;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AAxEd;AA2EY;EACE,iBAAA;EACA,gBAAA;EACA,cC5pBN;ADmlBR;AExgBI;EF8kBQ;IAMI,kBAAA;EAxEd;AACF","sourcesContent":["@use 'src/assets/styles/colors' as colors;\n@use 'src/assets/styles/bootstrap-essentials' as be;\n\n// Campaign color variables\n$green: colors.$green;\n$brown: colors.$brown;\n$light-brown: colors.$light-brown;\n$yellow: colors.$yellow;\n$red: colors.$red;\n\n.analytics-dashboard {\n  background: $red;\n  min-height: 100vh;\n  padding: clamp(2rem, 5vw, 4rem) 0;\n\n  // Password Prompt\n  .password-prompt {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 80vh;\n    padding: 2rem;\n\n    .password-card {\n      background: white;\n      border-radius: 16px;\n      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);\n      padding: 3rem;\n      max-width: 450px;\n      width: 100%;\n      text-align: center;\n\n      @include be.media-breakpoint-down(md) {\n        padding: 2rem;\n      }\n\n      h2 {\n        font-size: 2rem;\n        font-weight: 700;\n        color: $red;\n        margin-bottom: 1rem;\n        text-transform: uppercase;\n        letter-spacing: 0.5px;\n\n        @include be.media-breakpoint-down(md) {\n          font-size: 1.5rem;\n        }\n      }\n\n      p {\n        color: #666;\n        font-size: 1rem;\n        margin-bottom: 2rem;\n        line-height: 1.5;\n      }\n\n      form {\n        .form-group {\n          margin-bottom: 1.5rem;\n\n          .password-input {\n            width: 100%;\n            padding: 1rem 1.5rem;\n            font-size: 1rem;\n            border: 2px solid #e0e0e0;\n            border-radius: 50px;\n            outline: none;\n            transition: all 0.3s ease;\n            font-family: inherit;\n\n            &:focus {\n              border-color: $green;\n              box-shadow: 0 0 0 3px rgba(0, 130, 61, 0.1);\n            }\n\n            &.error {\n              border-color: $red;\n            }\n\n            &::placeholder {\n              color: #999;\n            }\n          }\n\n          .error-message {\n            color: $red;\n            font-size: 0.875rem;\n            margin-top: 0.75rem;\n            font-weight: 500;\n            text-align: left;\n            padding-left: 1.5rem;\n          }\n        }\n\n        .btn-submit {\n          width: 100%;\n          padding: 1rem 2rem;\n          background-color: $green;\n          color: white;\n          border: none;\n          border-radius: 50px;\n          cursor: pointer;\n          font-size: 1rem;\n          font-weight: 700;\n          text-transform: uppercase;\n          letter-spacing: 0.5px;\n          transition: all 0.3s ease;\n          box-shadow: 0 4px 8px rgba(0, 130, 61, 0.2);\n\n          &:hover {\n            background-color: darken($green, 8%);\n            transform: translateY(-2px);\n            box-shadow: 0 6px 12px rgba(0, 130, 61, 0.3);\n          }\n\n          &:active {\n            transform: translateY(0);\n          }\n        }\n      }\n    }\n  }\n\n  // Container\n  .analytics-header,\n  .summary-section,\n  .trend-section {\n    max-width: 1400px;\n    margin: 0 auto;\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n\n    @include be.media-breakpoint-down(md) {\n      padding-left: 1rem;\n      padding-right: 1rem;\n    }\n  }\n\n  // Header\n  .analytics-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 2rem;\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n    background: white;\n    border-radius: 12px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n\n    @include be.media-breakpoint-down(md) {\n      flex-direction: column;\n      gap: 1rem;\n      padding: 1.5rem;\n    }\n\n    .dashboard-title {\n      font-size: clamp(1.5rem, 4vw, 2.5rem);\n      font-weight: 700;\n      color: $red;\n      margin: 0;\n      text-transform: uppercase;\n      letter-spacing: 0.5px;\n\n      @include be.media-breakpoint-down(md) {\n        font-size: 1.5rem;\n        text-align: center;\n      }\n    }\n\n    .btn-refresh {\n      padding: 0.875rem 2rem;\n      background-color: $green;\n      color: white;\n      border: none;\n      border-radius: 50px;\n      cursor: pointer;\n      font-size: 1rem;\n      font-weight: 700;\n      text-transform: uppercase;\n      letter-spacing: 0.5px;\n      transition: all 0.3s ease;\n      box-shadow: 0 4px 8px rgba(0, 130, 61, 0.2);\n\n      &:hover {\n        background-color: darken($green, 8%);\n        transform: translateY(-2px);\n        box-shadow: 0 6px 12px rgba(0, 130, 61, 0.3);\n      }\n\n      &:active {\n        transform: translateY(0);\n      }\n\n      @include be.media-breakpoint-down(md) {\n        width: 100%;\n      }\n    }\n  }\n\n  // Loading State\n  .loading-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 4rem 2rem;\n    min-height: 300px;\n    background: white;\n    border-radius: 12px;\n\n    &.small {\n      min-height: 150px;\n      padding: 2rem;\n    }\n\n    .spinner {\n      width: 50px;\n      height: 50px;\n      border: 4px solid rgba(255, 255, 255, 0.3);\n      border-top: 4px solid $green;\n      border-radius: 50%;\n      animation: spin 1s linear infinite;\n      margin-bottom: 1rem;\n\n      &.small {\n        width: 30px;\n        height: 30px;\n        border-width: 3px;\n      }\n    }\n\n    p {\n      color: #666;\n      font-size: 1rem;\n      margin: 0;\n      font-weight: 500;\n    }\n  }\n\n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n\n  // Section Titles\n  .section-title {\n    font-size: clamp(1.5rem, 3vw, 2rem);\n    font-weight: 700;\n    color: white;\n    margin-bottom: 1.5rem;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n    text-align: center;\n\n    @include be.media-breakpoint-down(md) {\n      font-size: 1.5rem;\n    }\n  }\n\n  // Summary Section\n  .summary-section {\n    margin-bottom: 3rem;\n\n    .summary-cards {\n      display: grid;\n      grid-template-columns: repeat(5, 1fr);\n      gap: 1.5rem;\n\n      @include be.media-breakpoint-down(lg) {\n        grid-template-columns: repeat(3, 1fr);\n      }\n\n      @include be.media-breakpoint-down(md) {\n        grid-template-columns: repeat(2, 1fr);\n      }\n\n      @include be.media-breakpoint-down(sm) {\n        grid-template-columns: 1fr;\n      }\n    }\n\n    .summary-card {\n      background: white;\n      border-radius: 12px;\n      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n      overflow: hidden;\n      transition: all 0.3s ease;\n\n      &:hover {\n        transform: translateY(-6px);\n        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);\n      }\n\n      .card-header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 1.5rem;\n        background: $green;\n        color: white;\n\n        h3 {\n          margin: 0;\n          font-size: 1.1rem;\n          font-weight: 700;\n          text-transform: uppercase;\n          letter-spacing: 0.5px;\n        }\n\n        .card-icon {\n          font-size: 2rem;\n        }\n      }\n\n      .card-loading {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        padding: 3rem 1.5rem;\n        min-height: 200px;\n\n        .spinner {\n          width: 30px;\n          height: 30px;\n          border: 3px solid #f3f3f3;\n          border-top: 3px solid $green;\n          border-radius: 50%;\n          animation: spin 1s linear infinite;\n          margin-bottom: 0.5rem;\n\n          &.small {\n            width: 24px;\n            height: 24px;\n            border-width: 2px;\n          }\n        }\n\n        p {\n          color: #666;\n          font-size: 0.875rem;\n          margin: 0;\n        }\n      }\n\n      .card-body {\n        padding: 1.5rem;\n\n        .stat-main {\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          margin-bottom: 1.5rem;\n\n          .stat-value {\n            font-size: 2.75rem;\n            font-weight: 700;\n            color: $green;\n            line-height: 1;\n\n            &.small {\n              font-size: 1.5rem;\n            }\n          }\n\n          .stat-label {\n            font-size: 0.9rem;\n            color: #666;\n            margin-top: 0.5rem;\n            text-transform: uppercase;\n            letter-spacing: 0.5px;\n            font-weight: 600;\n          }\n        }\n\n        .stat-percentage {\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          margin-bottom: 1.5rem;\n          padding: 1rem;\n          background: lighten($red, 40%);\n          border-radius: 8px;\n\n          &.success {\n            background: lighten($red, 40%);\n          }\n\n          .percentage-value {\n            font-size: 2rem;\n            font-weight: 700;\n            color: $red;\n          }\n\n          .percentage-label {\n            font-size: 0.85rem;\n            color: #666;\n            margin-top: 0.25rem;\n            font-weight: 500;\n          }\n        }\n\n        .stat-row {\n          display: flex;\n          justify-content: space-around;\n          gap: 1rem;\n          margin-bottom: 1rem;\n\n          .stat-item {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            flex: 1;\n\n            .stat-value {\n              font-size: 1.5rem;\n              font-weight: 700;\n              color: $brown;\n\n              &.small {\n                font-size: 1.25rem;\n              }\n            }\n\n            .stat-label {\n              font-size: 0.75rem;\n              color: #999;\n              margin-top: 0.25rem;\n              text-transform: uppercase;\n              font-weight: 600;\n            }\n          }\n        }\n\n        .stat-breakdown {\n          display: flex;\n          flex-direction: column;\n          gap: 0.75rem;\n          margin-bottom: 1rem;\n\n          .breakdown-item {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            padding: 0.875rem;\n            border-radius: 8px;\n            background: $light-brown;\n\n            &.pending {\n              background: lighten($yellow, 35%);\n              border-left: 4px solid $yellow;\n            }\n\n            &.partial {\n              background: lighten($brown, 35%);\n              border-left: 4px solid $brown;\n            }\n\n            &.completed {\n              background: lighten($green, 50%);\n              border-left: 4px solid $green;\n            }\n\n            &.approved {\n              background: lighten($green, 50%);\n              border-left: 4px solid $green;\n            }\n\n            &.handled {\n              background: lighten($brown, 35%);\n              border-left: 4px solid $brown;\n            }\n\n            .breakdown-value {\n              font-size: 1.25rem;\n              font-weight: 700;\n              color: #333;\n            }\n\n            .breakdown-label {\n              font-size: 0.85rem;\n              color: #666;\n              font-weight: 500;\n            }\n          }\n        }\n\n        .stat-footer {\n          display: flex;\n          flex-direction: column;\n          gap: 0.5rem;\n          padding-top: 1rem;\n          border-top: 2px solid #e0e0e0;\n\n          small {\n            font-size: 0.8rem;\n            color: #999;\n            font-weight: 500;\n          }\n        }\n      }\n    }\n  }\n\n  // Trend Section\n  .trend-section {\n    background: white;\n    border-radius: 12px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    padding: 2rem;\n    margin-bottom: 2rem;\n\n    @include be.media-breakpoint-down(md) {\n      padding: 1.5rem;\n    }\n\n    .section-title {\n      color: $red;\n      text-align: left;\n      margin-bottom: 1rem;\n    }\n\n    .trend-header {\n      margin-bottom: 2rem;\n\n      .controls-group {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        flex-wrap: wrap;\n        gap: 1rem;\n        margin-top: 1rem;\n\n        @include be.media-breakpoint-down(md) {\n          flex-direction: column;\n          align-items: stretch;\n        }\n\n        .category-selector {\n          display: flex;\n          gap: 0.5rem;\n          flex-wrap: wrap;\n\n          @include be.media-breakpoint-down(sm) {\n            flex-direction: column;\n          }\n\n          .category-btn {\n            padding: 0.75rem 1.25rem;\n            background: white;\n            border: 2px solid $green;\n            border-radius: 50px;\n            cursor: pointer;\n            font-size: 0.9rem;\n            font-weight: 600;\n            color: $green;\n            transition: all 0.3s ease;\n            text-transform: uppercase;\n            letter-spacing: 0.5px;\n\n            &:hover {\n              background: lighten($green, 50%);\n            }\n\n            &.active {\n              background: $green;\n              color: white;\n              box-shadow: 0 4px 8px rgba(0, 130, 61, 0.2);\n            }\n\n            @include be.media-breakpoint-down(sm) {\n              width: 100%;\n              text-align: center;\n            }\n          }\n        }\n\n        .time-range-selector {\n          display: flex;\n          gap: 0.25rem;\n          background: $light-brown;\n          padding: 0.25rem;\n          border-radius: 50px;\n\n          @include be.media-breakpoint-down(md) {\n            width: 100%;\n          }\n\n          .range-btn {\n            padding: 0.625rem 1.5rem;\n            background: transparent;\n            border: none;\n            border-radius: 50px;\n            cursor: pointer;\n            font-size: 0.9rem;\n            font-weight: 600;\n            color: #666;\n            transition: all 0.3s ease;\n            text-transform: uppercase;\n            letter-spacing: 0.5px;\n            flex: 1;\n\n            &:hover {\n              background: darken($light-brown, 5%);\n            }\n\n            &.active {\n              background: $green;\n              color: white;\n              box-shadow: 0 2px 6px rgba(0, 130, 61, 0.3);\n            }\n          }\n        }\n      }\n    }\n\n    .trend-content {\n      .chart-wrapper {\n        .chart-container {\n          position: relative;\n          height: 450px;\n          width: 100%;\n          padding: 1.5rem;\n          background: white;\n          border-radius: 12px;\n          border: 2px solid $light-brown;\n          margin-bottom: 1.5rem;\n\n          @include be.media-breakpoint-down(md) {\n            height: 300px;\n            padding: 1rem;\n          }\n\n          canvas {\n            max-height: 100%;\n          }\n        }\n\n        .chart-stats {\n          display: flex;\n          justify-content: center;\n          flex-wrap: wrap;\n          gap: 2rem;\n          padding: 1.5rem;\n          background: $light-brown;\n          border-radius: 12px;\n\n          @include be.media-breakpoint-down(sm) {\n            gap: 1rem;\n          }\n\n          .stat-item {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            gap: 0.5rem;\n\n            .stat-label {\n              font-size: 0.85rem;\n              color: #666;\n              font-weight: 600;\n              text-transform: uppercase;\n              letter-spacing: 0.5px;\n            }\n\n            .stat-value {\n              font-size: 1.5rem;\n              font-weight: 700;\n              color: $green;\n\n              @include be.media-breakpoint-down(sm) {\n                font-size: 1.25rem;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n","$brown: #cca374;\n$green: #00823d;\n$light-brown: #eaedd2;\n$yellow: #ffcc00;\n$red: #e5052a;\n$brand-bg: #f4002c;\n$header-bg: #000000;\n$white: #ffffff;\n$body-text: #ffffff;","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
